(() => {
  if (customElements.get('ff-delivery-progress')) return;
  let request = null;
  const readCart = () => {
    if (!request) {
      request = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(response => {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }).finally(() => { request = null; });
    }
    return request;
  };
  class ForgeDeliveryProgress extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold);
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-GB', {
        style: 'currency', currency: 'GBP'
      });
      this.message = this.querySelector('.ff-delivery-progress__message');
      this.track = this.querySelector('.ff-delivery-progress__track');
      this.fill = this.querySelector('.ff-delivery-progress__fill');
      this.total = this.querySelector('[data-ff-delivery-total]');
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          const cart = event?.cartData;
          if (Number.isFinite(cart?.total_price) && Array.isArray(cart.items)) this.update(cart);
        });
      }
      this.notification = this.closest('#cart-notification');
      if (this.notification) {
        this.observer = new MutationObserver(() => {
          if (this.notification.classList.contains('active')) this.refresh();
        });
        this.observer.observe(this.notification, { attributes: true, attributeFilter: ['class'] });
        if (this.notification.classList.contains('active')) this.refresh();
      }
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.observer?.disconnect();
    }
    async refresh() {
      this.dataset.pending = 'true';
      try { this.update(await readCart()); }
      catch { this.hidden = true; }
      finally { this.dataset.pending = 'false'; }
    }
    update(cart) {
      const items = Array.isArray(cart.items) ? cart.items : [];
      this.hidden = this.dataset.country !== 'GB' || cart.currency !== 'GBP' ||
        !Number.isFinite(this.threshold) || this.threshold <= 0 ||
        !items.length || items.some(item => item.requires_shipping !== true);
      if (this.hidden) return;
      const amount = Math.max(0, cart.total_price);
      const remaining = Math.max(0, this.threshold - amount);
      const message = remaining ? this.dataset.below : this.dataset.reached;
      this.message.replaceChildren();
      if (remaining && message.includes('[amount]')) {
        const parts = message.split('[amount]');
        parts.forEach((part, index) => {
          this.message.append(document.createTextNode(part));
          if (index < parts.length - 1) {
            const strong = document.createElement('strong');
            strong.textContent = this.money.format(remaining / 100);
            this.message.append(strong);
          }
        });
      } else this.message.textContent = message;
      this.fill.style.width = `${Math.min(100, amount / this.threshold * 100)}%`;
      this.track.setAttribute('aria-valuenow', String(Math.min(amount, this.threshold)));
      this.track.setAttribute('aria-valuetext',
        `${this.money.format(amount / 100)} / ${this.money.format(this.threshold / 100)}`);
      this.total.textContent = this.money.format(amount / 100);
      this.dataset.pending = 'false';
    }
  }
  customElements.define('ff-delivery-progress', ForgeDeliveryProgress);
})();
